import "./Item.scss";

function SearchResultItem({ item, handleClickItem }) {
  const details = Object.entries(item.details || {}) || [];

  if (!item || !item.product_id) return null;

  return (
    <div
      className={[
        `beon-showcase__item`,
        `beon-interaction__item`,
        item?.is_available ? `bn-available` : `bn-unavailable`,
      ].join(` `)}
      data-product-id={item?.product_id}
      data-product-sku={item?.sku}
      data-product-extra='["", ""]'
      onClick={() => handleClickItem(item)}
    >
      <div className="beon-showcase__item-title">
        <a
          href={item?.url}
          title={item?.name}
          data-action="details"
          data-track="click"
          data-event='["Detalhes", null, null]'
          data-bind="true"
        >
          <span>{item?.name}</span>
        </a>
      </div>
      <ul className="beon-showcase__item-details">
        {details?.map((detail) => (
          <li className={`detail-${detail[0]}`}>{detail[1]}</li>
        ))}
      </ul>
      <div className="beon-showcase__item-references">
        <span className="beon-product__sku">{item.sku}</span>{" "}
        <span className="beon-product__id">{item.product_id}</span>
      </div>
      <div className="beon-showcase__item-tags"></div>
      <div className="beon-showcase__review"></div>
      {item?.images && item?.images.length && (
        <div className="beon-showcase__item-image">
          <a
            href={item?.url}
            title={item?.name}
            data-action="details"
            data-track="click"
            data-event='["Detalhes", null, null]'
            data-bind="true"
          >
            <img
              className="bn-lazy loaded tns-complete"
              data-src={item?.images[0]}
              alt={item?.name}
              src={item?.images[0]}
            />
          </a>
        </div>
      )}
      <div className="beon-showcase__item-description">
        {item?.price_to > 0 && (
          <div
            className={`beon-showcase__item-price-box beon-showcase__item-price-box--${
              item?.is_promo ? "special" : "simple"
            }`}
          >
            {item?.price_from > 0 && item?.is_promo && (
              <span className="beon-showcase__item-price beon-showcase__item-price--from">
                <span className="prefix">De:</span>
                <span className="beon-showcase__price">
                  <span className="currency">R$ </span>
                  <span className="value">{item?.price_from}</span>
                </span>
              </span>
            )}

            <span className="beon-showcase__item-price beon-showcase__item-price--to">
              <span className="prefix"> por: </span>{" "}
              <span className="beon-showcase__price">
                <span className="currency">R$ </span>
                <span className="value">
                  {(item?.price_to).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </span>
            </span>
            {item?.installment_amount > 0 && (
              <span className="beon-showcase__item-installments">
                <span className="null"> ou </span>{" "}
                <strong className="beon-interaction__installmentsCount">
                  {" "}
                  {item?.installment_months}x{" "}
                </strong>{" "}
                <span className="null"> de </span>
                <strong className="beon-interaction__installmentPrice">
                  {" "}
                  <span className="currency">R$ </span>
                  <span className="value">
                    {(item?.installment_amount).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </span>{" "}
                </strong>
              </span>
            )}
            {item?.additional_prices && item?.additional_prices?.avista && (
              <span className="beon-showcase__item-avista">
                {" "}
                <strong className="beon-showcase__item-price">
                  {" "}
                  <span className="currency">R$ </span>
                  <span className="value">
                    {(item?.additional_prices?.avista).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </span>{" "}
                </strong>{" "}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="beon-showcase__item-badges">
        {item.is_promo && (
          <span className="beon-showcase__item-badge beon-showcase__item-badge--off">
            <span className="beon-showcase__item-discount">
              {item?.price_discount_off}%
            </span>
            <span className="null">off</span>
          </span>
        )}

        <span
          className={`beon-showcase__item-badge beon-showcase__item-badge--${
            item?.is_available ? `available` : `unvailable`
          }`}
        >
          <span>
            {item?.is_available ? `Entrega imediata` : `Produto indisponível`}
          </span>
        </span>

        {item?.is_new && (
          <span class="beon-showcase__item-badge beon-showcase__item-badge-new">
            <span>Lançamento</span>{" "}
          </span>
        )}
      </div>

      <div className="beon-showcase__item-actions">
        <a
          href={item?.url}
          className="beon-button beon-button--primary"
          data-action="details"
          data-track="click"
          data-event='["Detalhes", null, null]'
          data-bind="true"
        >
          <span className="beon-button__label beon-button__label--details">
            Ver detalhes
          </span>
        </a>
      </div>
    </div>
  );
}

export default SearchResultItem;